import {
  getStartupLanguage,
  resources,
  saveStartupLanguage,
  supportedLanguages,
} from '@/shared/i18n/index.startup';

export const showStartupError = (
  root: HTMLElement,
  retry: () => void,
): void => {
  let language = getStartupLanguage();
  const panel = document.createElement('main');
  panel.className =
    'mx-auto flex min-h-dvh max-w-sm flex-col justify-center gap-4 p-6';
  const title = document.createElement('h1');
  title.className = 'text-xl font-bold';
  const description = document.createElement('p');
  description.className = 'text-base text-muted-foreground';
  description.setAttribute('role', 'alert');
  const languageLabel = document.createElement('label');
  languageLabel.htmlFor = 'startup-language';
  const languageSelect = document.createElement('select');
  languageSelect.id = 'startup-language';
  languageSelect.className =
    'min-h-12 rounded-xl border bg-background px-4 text-base';
  for (const supportedLanguage of supportedLanguages) {
    const option = document.createElement('option');
    option.value = supportedLanguage;
    option.textContent =
      resources[supportedLanguage].translation.language.option[
        supportedLanguage
      ];
    languageSelect.append(option);
  }
  languageSelect.value = language;
  const button = document.createElement('button');
  button.type = 'button';
  button.className =
    'min-h-12 rounded-xl bg-primary px-4 text-base font-bold text-primary-foreground';

  const updateLanguage = (): void => {
    const translations = resources[language].translation;
    document.documentElement.lang = language;
    title.textContent = translations.startup.title;
    description.textContent = translations.startup.description;
    languageLabel.textContent = translations.language.label;
    button.textContent = translations.startup.retry;
  };
  languageSelect.addEventListener('change', () => {
    language =
      supportedLanguages.find(
        (candidate) => candidate === languageSelect.value,
      ) ?? language;
    saveStartupLanguage(language);
    updateLanguage();
  });
  button.addEventListener('click', () => {
    button.disabled = true;
    languageSelect.disabled = true;
    button.textContent = resources[language].translation.startup.loading;
    retry();
  });
  updateLanguage();
  panel.append(title, description, languageLabel, languageSelect, button);
  root.replaceChildren(panel);
};
